import Mutations from '../../odata/mutations';

export default { ...new Mutations('clientAttachment'), ...new Mutations('clientAttachments') };
